import React, { useState, useEffect } from "react";
import {
  ButtonGroup,
  Button,
  Icon,
} from '../../ui-components';
import {
  Wrap,
  WrapGrid,
  SubMenuButton,
  SubMenuSep,
  SubMenuWrap,
  ButtonActive,
} from './feature-viewer.styled';
import FeatureImages from './feature-images';
import { FeatureInfo } from './feature-info';
import { COLLECTION, FEATURE_MAP } from './feature-list';
import { FeatureDot, FeatureDotAnchor } from "./feature-info.styled";



const BUTTON_SIZE = "normal";

const FeatureState = ({ data, handleChange }) => {
  const isCamper = data === 'camper';
  const isBoat = data === 'boat';
  const isTrike = data === 'trike';
  const isCamperColer = isCamper ? 'primary' : 'white';
  const isBoatColor = isBoat ? 'primary' : 'white';
  const isTrikeColor = isTrike ? 'primary' : 'white';
  return (
    <ButtonGroup size={BUTTON_SIZE} color="secondary">
      <Button
        type="button"
        color={isBoatColor}
        size={BUTTON_SIZE}
        onClick={(e) => { handleChange('boat') }}
      >
        {isBoat ? <ButtonActive /> : null}
        Boat
      </Button>
      <Button
        type="button"
        color={isCamperColer}
        size={BUTTON_SIZE}
        onClick={(e) => { handleChange('camper') }}
      >
        {isCamper ? <ButtonActive /> : null}
        Camp
      </Button>
      <Button
        type="button"
        color={isTrikeColor}
        size={BUTTON_SIZE}
        onClick={(e) => { handleChange('trike') }}
      >
        {isTrike ? <ButtonActive /> : null}
        Trike
      </Button>
    </ButtonGroup>
  )
};



const SubMenu = ({ open, handleOpen, rotation, maxRotation, handleRotation }) => {
  const size = 14;
  return (
    <SubMenuWrap>
      <SubMenuButton
        type="button"
        onClick={(e) => { handleOpen(!open) }}
      >
        <Icon
          name={open ? "corner-up-right" : "corner-up-left"}
          width={size}
          height={size}
          noFill
        />
        {open ? "Open" : "Close"}
      </SubMenuButton>
      <SubMenuSep />
      <SubMenuButton
        type="button"
        onClick={() => { handleRotation("right") }}
        disabled={rotation === maxRotation}
      >
        <Icon
          name="arrowhead-left"
          width={size}
          height={size}
          noFill
        />
        Left
      </SubMenuButton>
      <SubMenuButton
        type="button"
        onClick={() => { handleRotation("left") }}
        disabled={rotation === 0}
      >
        Right
        <Icon
          name="arrowhead-right"
          width={size}
          height={size}
          noFill
        />
      </SubMenuButton>
    </SubMenuWrap>
  )
}

const MAX_CANVA = 944;

export const FeatureViewer = ({ domain = "ready_made" }) => {
  const [feature, setFeature] = useState('trike');
  const [open, setOpen] = useState(true);
  const [rotation, setRotation] = useState(0);
  const [info, setInfo] = useState(null);
  const [canvaWidth, setCanvaWidth] = useState(MAX_CANVA)
  const imgName = `${domain}_feature_${feature}_${!open ? 'open' : 'closed'}_${rotation}`;
  const featureDotMap = FEATURE_MAP[imgName] || [];
  const infoData = featureDotMap.find(el => el.tag === info);
  const modifier = canvaWidth * 100 / MAX_CANVA / 100;

  useEffect(() => {
    const width = document.getElementById('canva')?.clientWidth || 0;
    setCanvaWidth(width);
    document.addEventListener("keydown", escFunction, false);
  }, []);

  useEffect(() => {
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);

  const handleFeature = (name) => {
    setFeature(name);
    setInfo(null);
  }

  const handleOpen = (name) => {
    setOpen(name);
    setInfo(null);
  }

  const handleRotation = (direction) => {
    let newRotation = rotation;

    const collection = COLLECTION[feature][open ? "open" : "closed"];
    if (direction === "left") {
      if (rotation - 1 <= 0) {
        newRotation = 0;
      } else {
        newRotation = rotation - 1;
      }
    }
    if (direction === "right") {
      if (rotation + 1 >= collection.length) {
        newRotation = 0;
      } else {
        newRotation = rotation + 1;
      }
    }
    setRotation(newRotation);
    setInfo(null);
  }

  const handleInfo = (name) => {
    if (info === name) {
      setInfo(null);
    } else {
      setInfo(name);
    }
  }

  const handleClose = () => {
    setInfo(null);
  }

  const escFunction = (event) => {
    if (event.keyCode === 27) {
      handleClose();
    }
  }

  return (
    <Wrap>
      <WrapGrid state>
        <FeatureState data={feature} handleChange={handleFeature} />
        <br />
        <SubMenu
          open={open}
          handleOpen={handleOpen}
          rotation={rotation}
          maxRotation={2}
          handleRotation={handleRotation}
        />
      </WrapGrid>
      <WrapGrid canva id="canva">
        <FeatureImages name={imgName} />
        {featureDotMap.map((feature, index) => {
          return (
            <FeatureDotAnchor
              key={index}
              x={feature.x * modifier}
              y={feature.y * modifier}>
              <FeatureDot
                type="button"
                desktoponly={feature.desktoponly === true || false}
                selected={info === feature.tag ? true : false}
                onClick={() => { handleInfo(feature.tag) }}>
                <Icon
                  name={info === feature.tag ? "close-outline" : "plus-outline"}
                  width={18}
                  height={18}
                  noFill
                />
              </FeatureDot>
            </FeatureDotAnchor>)
        })}
        {infoData
          ? <FeatureInfo data={infoData} handleClose={handleClose} />
          : ''}
      </WrapGrid>
    </Wrap>
  )
}

export default FeatureViewer;